import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import { inject, observer } from 'mobx-react';
import { colors } from './constants';
import { ArrowRightIcon } from './ArrowRightIcon';
import { get } from 'lodash';
import { SPONSORSHIPS } from '../../../constants';
import { formatCentToUsd } from './helpers';

const propTypes = {
    classes: PropTypes.object.isRequired
}

@inject('auth', 'store') @observer
class SponsorshipsBanner extends React.Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        const { store } = this.props;
        const { track } = store;
        track({
                "feature": 'public_pages',
                "name": "chatstats_push_to_sponsorships_banner_load",
                "type": "page_load",
                "product": "dashboard",
                "fields": [
                    ['sponsorships_count', store.sponsorships.length],
                ]
            });
    }

    render() {
        const { classes, store } = this.props;
        const { sponsorships, track } = store;

        const sponsorship = sponsorships.length === 1 ? sponsorships[0] : null;
        const advertiserName = get(sponsorship, 'advertiserName', null)
        const titleText = !!sponsorship ? `You have a ${advertiserName || 'new'} sponsorship opportunity!` : 'You have several sponsorship opportunities right now!';
        const buttonText = !!sponsorship ? 'Check It Out' : 'Check Them Out';
        const linkUrl = !!sponsorship ? `${SPONSORSHIPS.URL_SPONSORSHIPS_SINGLE_BASE}/${sponsorship.id}` : SPONSORSHIPS.URL_SPONSORSHIPS_MULTI;

        // Get the highest max payable amount for the payout
        const payout = sponsorships.reduce((acc, curr) => {
            const currentMaxPayableAmount = get(curr, 'maxPayableAmount', 0)
            if (currentMaxPayableAmount > acc) {
            return currentMaxPayableAmount;
            }
            return acc;
        }, 0);
        const payoutText = `Sponsorships with payouts are up to ${formatCentToUsd(payout)} are waiting for you`;

        return (
            <div className={classes.root}>
                    <div className={!!sponsorship ? classes.singleHeroWrapper : classes.multiHeroWrapper}>
                        <img className={!!sponsorship ? classes.singleHero : classes.multiHero} src={get(sponsorship, 'selfServeConfiguration.heroImageUrl', 'https://cdn.streamelements.com/assets/chat-stats-assets/bannerV2/multi_sponsorships_hero.png')} />
                    </div>
                    
                    <div className={classes.contentWrapper}>

                    <div className={classes.textWrapper}>
                        <h2 className={classes.title}>{titleText}</h2>
                        <h3 className={classes.subtitle}>{payoutText}</h3>
                    </div>
                    <div className={classes.buttonWrapper}>
                        <a className={classes.button} href={linkUrl} onClick={e => {
                            const extraFields = !!sponsorship ? [['sponsorship_id', sponsorships.id]] : []
                            track({
                                "feature": 'public_pages',
                                "name": !!sponsorship ? "chatstats_push_to_sponsorships_banner_single_click" : "chatstats_push_to_sponsorships_banner_multi_click",
                                "type": "click",
                                "product": "dashboard",
                                "fields": [
                                    ['sponsorships_count', store.sponsorships.length],
                                    ...extraFields
                                ]
                            });
                        }}>
                            {buttonText}
                            <ArrowRightIcon />
                        </a>
                    </div>
                </div>
            </div>     
        )
    }
}

const styles = theme => ({
    root: {
        background: colors.heroBlue,
        borderRadius: '8px',
        marginBottom: '8px',
        display: 'flex',
        overflow: 'hidden',

        [theme.devices.large]: {
            paddingRight: '22px'
        },
        '@media (max-width: 760px)': {
            paddingRight: 0,
            flexDirection: 'column',
        }
    },
    singleHeroWrapper: {
        padding: '36px 56px 36px 36px',

        '@media (max-width: 760px)': {
            padding: '22px'
        }
    },
    singleHero: {
        maxHeight: '143px',
        height: '100%',
        width: 'auto',

        '@media (max-width: 760px)': {
            maxHeight: 'unset',
            width: '100%',
            marginRight: 0
        }
    },
    multiHeroWrapper: {
        alignSelf: 'flex-end',
        margin: 0,
        padding: '0 36px 0 0',

        '@media (max-width: 760px)': {
            alignSelf: 'center',
            padding: 0,
            marginBottom: '22px'
        }
    },
    multiHero: {
        height: '100%',
        maxHeight: '214px',
        width: 'auto',
        verticalAlign: 'bottom',

        '@media (max-width: 760px)': {
            maxHeight: 'unset',
            width: '100%',
            marginRight: 0
        }
    },
    contentWrapper: {
        display: 'flex',
        '@media (max-width: 1224px)': {
            flexDirection: 'column'
        },
    },
    textWrapper: {
        padding: '36px 0',

        '@media (max-width: 760px)': {
            padding:'0 22px',
            marginBottom: '22px',
        }
    },
    title: {
        fontFamily: 'Nunito Sans',
        color: colors.white,
        fontSize: '38px',
        fontWeight: 700,
        lineHeight: '42px',
        marginBottom: '14px',

        [theme.devices.large]: {
            fontSize: '28px',
            lineHeight: '31px',
        },
    },
    subtitle: {
        fontFamily: 'Nunito Sans',
        color: colors.white,
        fontSize: '20px',
        fontWeight: 700,
        lineHeight: 'normal',

        [theme.devices.large]: {
            fontSize: '14px',
            lineHeight: '16px',
        }

    },
    buttonWrapper: {
        minWidth: 'fit-content',
        paddingRight: '36px',
        paddingLeft: '22px',
        alignSelf: 'center',

        '@media (max-width: 1224px)': {
            alignSelf: 'flex-start',
            padding: '0 0 36px 0',
        },
        '@media (max-width: 760px)': {
            padding: '0 22px',
            margin:'0 0 22px',
            display: 'flex',
            justifyContent: 'center',
            width: '100%'
        }
    },
    button: {
        textDecoration: 'none',
        background: colors.offWhite,
        color: colors.black,
        padding: '20px 42px',
        borderRadius: '70px',
        fontFamily: 'Work Sans',
        fontSize: '20px',
        fontWeight: 600,
        textTransform: 'uppercase',
        display: 'inline-flex',
        gap: '9px',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.devices.large]: {
            fontSize: '16px',
            lineHeight: '22px',
        },
        '@media (max-width: 760px)': {
            display: 'flex',
            flex: 1
        }
    }
});

SponsorshipsBanner.propTypes = propTypes;

export default injectSheet(styles)(SponsorshipsBanner);



// WEBPACK FOOTER //
// ./src/app/components/bannerV2/SponsorshipsBanner.js